<!--
	AboutPage.svelte

    NOTE: this page is no longer used - About links to the main TCARE site.
-->


<script>
	import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition';

    // TCARE components
    import PageBanner from '../../components/common/PageBanner.svelte';

    onMount(() => {
    })

</script>

<style>
</style>

<div class="page-content about-page" in:fly="{{ x: 200, duration: 500 }}" out:fade="{{ duration: 250 }}">
    <div class="spacer-h-25"></div>
    <PageBanner title="About TCARE Connect"/>
    <div class="spacer-h-25"></div>
    v 0.11.05.01 feature/resource-menu
</div>
